@if (isRequired) {
	<span class="error">*</span>
} @else {
	<span class="optionally">{{ 'form.validation.optionally' | translate }}</span>
}
